
define('text!libs/strand/src/strand-input/example.html',[],function () { return '<!-- Default Example -->\n<strand-input></strand-input>\n<!-- Search and Clear Example -->\n<strand-input placeholder="Search and Clear" search clear></strand-input>\n<!-- Clear and Custom Icon Example -->\n<strand-input placeholder="Icon and Clear" icon="calendar" clear width="250"></strand-input>';});

